import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import type { PromotedBundleEdge } from '@/@types/graphql-types';
import type { BuyboxPresentationType } from '@/stores/pinia/useUserStore';

import { MonetizationType } from '@/@types/graphql-types';

import GridOffer from '@/features/buybox/components/grid/GridOffer.vue';
import BundleOffer from '@/features/buybox/components/grid/BundleOffer.vue';

import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

type BuyboxRowOffer = TitleOfferFragment & {
	iconUrl?: string;
	icons?: string[];
	bundleId?: number;
	bundleTechnicalName?: string;
};

interface BuyBoxRowProps {
	title: TitleDetail;
	promoted?: boolean;
	inline?: boolean;
	hideCategoryLabel?: boolean;
	additionalContexts?: SnowplowContext[];
	offers?: BuyboxRowOffer[];
	bundles?: PromotedBundleEdge[];
	isBannerBuyBox?: boolean;
	// START AVOD
	isAVODActive?: boolean;
	// END AVOD
	activePresentationType?: BuyboxPresentationType | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferRow',
  props: {
    title: null,
    promoted: { type: Boolean },
    inline: { type: Boolean },
    hideCategoryLabel: { type: Boolean },
    additionalContexts: { default: () => [] },
    offers: { default: () => [] },
    bundles: { default: () => [] },
    isBannerBuyBox: { type: Boolean },
    isAVODActive: { type: Boolean },
    activePresentationType: null
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, promoted?: boolean, inline?: boolean, hideCategoryLabel?: boolean, additionalContexts: SnowplowContext[], offers: BuyboxRowOffer[], bundles: PromotedBundleEdge[], isBannerBuyBox?: boolean, isAVODActive?: boolean, activePresentationType?: BuyboxPresentationType | null };



const { isTTBLanguage } = storeToRefs(useLanguageStore());

const bundleOffers = computed(() => {
	return props.bundles.map(bundle => {
		return {
			...bundle.offer,
			standardWebURL: bundle.promotionUrl,
			bundleId: bundle.node.bundleId,
			bundleTechnicalName: bundle.node.technicalName,
			icons: bundle.node.packages.map(pkg => pkg.icon),
		};
	});
});

// START AVOD
const rowOffers = computed(() => {
	// Only show One Plex offer at a time.
	// + Always filtering out Justwatch-plex Provider as it's only used by partners.
	const AVODTechnicalName = props.isAVODActive
		? ['plex', 'justwatchplexchannel']
		: ['plexplayer', 'justwatchplexchannel'];

	// HIDE OTT Studio Channel from regular free offers when Player offer is present
	if (props.offers.some(offer => offer.package.technicalName === 'ottstudioplayer')) {
		AVODTechnicalName.push('ottstudiochannel');
	}
	const offers = [...props.offers.filter(el => !AVODTechnicalName.includes(el.package.technicalName))];

	// JUSTWATCH_TV
	const indexOfJustWatchTvOffer = offers.findIndex(offer => offer.package.shortName === 'jwt');
	const indexOfFirstFreeOffer = offers.findIndex(offer =>
		[MonetizationType.Ads, MonetizationType.Free].includes(offer.monetizationType)
	);
	if (indexOfJustWatchTvOffer > indexOfFirstFreeOffer) {
		const justWatchTVhOffer = offers.splice(indexOfJustWatchTvOffer, 1)[0];
		offers.splice(indexOfFirstFreeOffer, 0, justWatchTVhOffer);
	}
	// JUSTWATCH_TV

	return offers;
});
// END AVOD

return { __sfc: true,props, isTTBLanguage, bundleOffers, rowOffers, GridOffer, BundleOffer }
}

})